import { inject, Injectable } from '@angular/core';
import { safelyCreateHttpParams } from 'src/app/core/services/api/api-utils';
import { operations } from 'src/app/core/services/api/generated/ix-api.types';
import { IxRestApi } from 'src/app/core/services/api/ix-rest-api';

export type RoleName = operations['hideCurrentUserRole']['parameters']['path']['roleName'];

@Injectable()
export class HideUserRoleApiService {
  readonly #ixRestApi = inject(IxRestApi);

  hideUserRole(
    path: operations['hideCurrentUserRole']['parameters']['path'],
    query: operations['hideCurrentUserRole']['parameters']['query'],
  ) {
    return this.#ixRestApi.patch(
      { pathname: '/api/users/currentuser/roles/{roleName}/hide', options: { path } },
      undefined,
      { params: safelyCreateHttpParams(query) },
    );
  }

  unhideUserRole(
    path: operations['unhideCurrentUserRole']['parameters']['path'],
    query: operations['unhideCurrentUserRole']['parameters']['query'],
  ) {
    return this.#ixRestApi.patch(
      { pathname: '/api/users/currentuser/roles/{roleName}/unhide', options: { path } },
      undefined,
      { params: safelyCreateHttpParams(query) },
    );
  }

  unhideAllRoles() {
    return this.#ixRestApi.patch({ pathname: '/api/users/currentuser/roles/unhide', options: {} }, undefined);
  }
}
